// src/components/portal/LockOverlay.js
import React, { useState } from 'react';
import { useLanguage } from '../../context/LanguageContext';
import { C } from '../../styles/theme';

// ─── Brand tokens ─────────────────────────────────────────────────────────────
const FONT = "'Plus Jakarta Sans', sans-serif";

const LockIconSmall = ({ size = 18 }) => (
    <svg
        width={size}
        height={size}
        viewBox="0 0 24 24"
        fill="none"
        stroke={C.green}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
    >
        <path d="M8 11V7a4 4 0 0 1 8 0v4" />
        <rect x="3" y="11" width="18" height="11" rx="2" ry="2" />
    </svg>
);

const LockOverlay = ({ locked, requiredPlan = 'Pro', children, onUpgrade }) => {
    const { t } = useLanguage();
    const [hovered, setHovered] = useState(false);

    if (!locked) return children;

    const handleClick = () => {
        if (typeof onUpgrade === 'function') onUpgrade();
    };

    return (
        <div
            style={{ position: 'relative' }}
            onMouseEnter={() => setHovered(true)}
            onMouseLeave={() => setHovered(false)}
        >
            {/* Dimmed children */}
            <div
                style={{
                    opacity: 0.45,
                    filter: 'grayscale(0.4)',
                    pointerEvents: 'none',
                    userSelect: 'none',
                }}
            >
                {children}
            </div>

            {/* Upgrade overlay */}
            <div
                onClick={handleClick}
                style={{
                    position: 'absolute',
                    inset: 0,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    flexDirection: 'column',
                    gap: 8,
                    cursor: 'pointer',
                    background: 'rgba(255,255,255,0.55)',
                }}
            >
                {/* Icon circle */}
                <div
                    style={{
                        width: 36,
                        height: 36,
                        borderRadius: '50%',
                        background: C.greenLight,
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                    }}
                >
                    <LockIconSmall size={18} />
                </div>

                {/* Label */}
                <span
                    style={{
                        fontSize: 12,
                        fontWeight: 700,
                        color: C.greenDark,
                        fontFamily: FONT,
                        opacity: hovered ? 1 : 0.9,
                        transition: 'opacity 0.15s',
                    }}
                >
                    {t('upgrade_to_plan')} {requiredPlan}
                </span>
            </div>
        </div>
    );
};

export default LockOverlay;
